class HeaderTitle extends HTMLElement {
  constructor() {
    super();
  }

  get value() {
    return this.textContent;
  }

  set value(newValue) {
    this.textContent = newValue;
  }
}

customElements.define("header-title", HeaderTitle);
